import { Component, signal, input, output, OnInit, OnDestroy, effect, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';
import { Constants } from '../../../common/helper/Constants';
import { Subject, takeUntil, filter } from 'rxjs';
import { UserService } from '../../../common/service/user.service';

@Component({
  selector: 'gate-maintenance-banner',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './maintenance-banner.component.html',
  styleUrl: './maintenance-banner.component.scss'
})
export class MaintenanceBannerComponent implements OnInit, OnDestroy {
  public isVisible = signal(true);
  public collapsed = input<boolean>(false);
  public bannerVisibilityChange = output<boolean>();

  private readonly userService = inject(UserService);
  public isImpersonating = computed(() => 
    this.userService.isImpersonating() && 
    this.userService.getImpersonationContext()?.initiatorType == 'ACP_User'
  );

  private currentRoute = signal('');
  private readonly showFromDate = new Date('2026-06-20T00:00:00');
  private readonly showUntilDate = new Date('2026-06-20T12:00:00');
  private readonly allowedRoutes = [
    Constants.routes.catalogue(),
    Constants.routes.offer(),
    Constants.routes.approval()
  ];
  private destroy$ = new Subject<void>();

  constructor(private router: Router) {
    this.currentRoute.set(this.router.url);
    
    effect(() => {
      this.bannerVisibilityChange.emit(this.shouldShowBanner());
    });
  }

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        this.currentRoute.set(event.urlAfterRedirects);
        this.isVisible.set(true);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public closeBanner(): void {
    this.isVisible.set(false);
    this.bannerVisibilityChange.emit(false);
  }

  public shouldShowBanner(): boolean {
    const now = new Date();
    const isOnAllowedRoute = this.allowedRoutes.some(route => 
      this.currentRoute().startsWith('/' + route)
    );
    const isWithinDateRange = now >= this.showFromDate && now <= this.showUntilDate;
    
    return this.isVisible() && isWithinDateRange; //&& isOnAllowedRoute;
  }

  public stripHtml(html: string): string {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }
}

